// Norewyn søsterside handlings-logger (P4 Lag 2).
// Forudsætning: søsterappen kører SAMME Firebase-projekt som Halls (penpalsdragons).
// Skriver til den centrale 'audit_logs' i SAMME form som Halls' logGuardianAction,
// plus et 'site'-felt — så handlinger fra søstersider dukker op i Vagttårnet
// (Vogter-handlinger, Arbejdsfordeling, Kilder, Vogter-spejl) tydeligt mærket med site.
//
// BRUG: kald ved hvert staff-skrive-punkt, LIGE efter selve skrivningen. Eksempel:
//
//     import { logSisterAction } from './sisterAudit';
//     ...
//     await updateDoc(doc(db, 'room_schedules/' + roomId + '/rituals', id), payload);
//     logSisterAction(currentUser, 'campus', 'TID', 'OPRETTET_SKEMA', id, roomName);
//
// Kategorier (samme som Halls): 'KREATION' | 'RESPONS' | 'TID' | 'DIALOG' | 'KONTROL' | 'DESIGN'.
// Kun staff (admin/guardian/superadmin) logges; elever/forældre ignoreres.
// Selvforsynende (henter selv getFirestore) + fejler stille — må aldrig knække app'en.

const STAFF_ROLES = ['admin', 'guardian', 'superadmin'];

export function logSisterAction(
  user: { id?: string; uid?: string; username?: string; name?: string; role?: string } | null | undefined,
  site: string,
  category: 'KREATION' | 'RESPONS' | 'TID' | 'DIALOG' | 'KONTROL' | 'DESIGN',
  action: string,
  targetId?: string,
  targetName?: string
): void {
  try {
    if (!user) return;
    const uid = user.id || user.uid;
    const role = (user.role || '').toLowerCase();
    if (!uid || STAFF_ROLES.indexOf(role) < 0) return;
    import('firebase/firestore').then(m => {
      const db = m.getFirestore();
      const id = 'log_' + Date.now() + '_' + Math.floor(Math.random() * 100000); // random-suffix: ingen id-kollision
      m.setDoc(m.doc(db, 'audit_logs', id), {
        id,
        userId: uid,                                   // SKAL == auth.uid (rule-krav)
        userName: user.username || user.name || '',
        userRole: role,
        category,
        action,
        targetId: targetId || '',
        targetName: targetName || '',
        source: site,                                  // grupperer i Kilder
        site,                                          // søsterside-mærke
        timestamp: Date.now(),
      });
    }).catch(() => {});
  } catch (e) { /* stille */ }
}
